import { render } from "./enriching.vue?vue&type=template&id=66708ac8&scoped=true"
import script from "./enriching.vue?vue&type=script&lang=js"
export * from "./enriching.vue?vue&type=script&lang=js"

import "./enriching.vue?vue&type=style&index=0&id=66708ac8&lang=sass&scoped=true"

import exportComponent from "C:\\Users\\colin\\Documents\\WebProjects\\cee\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66708ac8"]])

export default __exports__